import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { useDebounce } from "hooks/useDebounce";
import classes from "./classes.module.scss";

type IProps = {
	searchQuery: string;
	setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
};

export default function SearchBar({ searchQuery, setSearchQuery }: IProps) {
	const [inputValue, setInputValue] = useState(searchQuery);
	const debouncedValue = useDebounce(inputValue, 300);

	useEffect(() => {
		setSearchQuery(debouncedValue);
	}, [debouncedValue, setSearchQuery]);

	useEffect(() => {
		setInputValue(searchQuery);
	}, [searchQuery]);

	return (
		<div className={classes["root"]}>
			<MagnifyingGlassIcon className={classes["search-icon"]} />
			<input
				type="text"
				placeholder="Rechercher les projets par le titre, le nom du porteur..."
				className={classes["text-input"]}
				value={inputValue}
				onChange={(e) => setInputValue(e.target.value)}
			/>
			<div className={classes["search-button"]}>
				<MagnifyingGlassIcon className={classes["search-button-icon"]} />
			</div>
		</div>
	);
}
